var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"outlined":"","dense":"","label":_vm.item.Attachment ? _vm.item.Attachment.Name : 'Загрузить файл'},on:{"change":_vm.setFile}})}
var staticRenderFns = []

export { render, staticRenderFns }